export const APP_ROUTES = [
  '/messages/:conversationId',
  '/chat/:conversationId',
  '/:conversationId',
  '/messages',
  '/chat',
  '/',
]
